var _excluded = ["size"];

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';

var Jcb24 = function Jcb24(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 16.298a3.11 3.11 0 0 1-3.105 3.105H2V7.105A3.11 3.11 0 0 1 5.105 4H22v12.298z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.499 13.144h1.283c.037 0 .122-.012.16-.012a.573.573 0 0 0 .451-.575.593.593 0 0 0-.452-.574c-.037-.012-.11-.012-.159-.012H16.5v1.173z",
    fill: "url(#jcb_24_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.636 5.04c-1.223 0-2.225.99-2.225 2.224v2.31h3.141c.074 0 .16 0 .22.013.71.036 1.235.403 1.235 1.039 0 .501-.354.929-1.014 1.014v.025c.72.049 1.271.452 1.271 1.076 0 .672-.611 1.112-1.418 1.112h-3.448v4.524h3.265c1.222 0 2.224-.99 2.224-2.226V5.04h-3.251z",
    fill: "url(#jcb_24_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.235 10.773a.52.52 0 0 0-.453-.526c-.024 0-.085-.012-.122-.012h-1.161v1.075h1.161c.037 0 .11 0 .122-.012a.52.52 0 0 0 .453-.525z",
    fill: "url(#jcb_24_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.337 5.04c-1.222 0-2.225.99-2.225 2.224v5.489c.624.306 1.272.501 1.92.501.77 0 1.186-.464 1.186-1.1V9.562h1.907v2.58c0 1.002-.624 1.821-2.739 1.821a9.427 9.427 0 0 1-2.286-.28v4.681h3.264c1.223 0 2.225-.99 2.225-2.225V5.04H5.337z",
    fill: "url(#jcb_24_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.486 5.04c-1.222 0-2.224.99-2.224 2.224v2.91c.562-.477 1.54-.783 3.117-.71.844.037 1.748.27 1.748.27v.94a4.231 4.231 0 0 0-1.687-.488c-1.198-.086-1.92.501-1.92 1.528 0 1.039.722 1.626 1.92 1.528.697-.049 1.235-.269 1.687-.489v.941s-.892.233-1.748.27c-1.577.073-2.555-.233-3.117-.71v5.135h3.264c1.222 0 2.225-.99 2.225-2.225V5.039h-3.264z",
    fill: "url(#jcb_24_svg__e)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_24_svg__a",
    x1: "15.409",
    y1: "12.559",
    x2: "20.902",
    y2: "12.559",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_24_svg__b",
    x1: "15.409",
    y1: "11.702",
    x2: "20.902",
    y2: "11.702",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_24_svg__c",
    x1: "15.409",
    y1: "10.771",
    x2: "20.902",
    y2: "10.771",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_24_svg__d",
    x1: "3.11",
    y1: "11.702",
    x2: "8.688",
    y2: "11.702",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".475",
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".826",
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_24_svg__e",
    x1: "9.23",
    y1: "11.702",
    x2: "14.648",
    y2: "11.702",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".173",
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".573",
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".859",
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#E60039"
  }))));
};

Jcb24.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Jcb32 = function Jcb32(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M32 19.162C32 21.829 29.77 24 27.032 24H0V4.838C0 2.171 2.23 0 4.968 0H32v19.162z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.198 14.248h2.054c.059 0 .196-.02.254-.02a.898.898 0 0 0 .724-.895c0-.457-.332-.8-.724-.895-.058-.019-.176-.019-.254-.019h-2.054v1.829z",
    fill: "url(#jcb_32_svg__a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.017 1.619c-1.956 0-3.56 1.543-3.56 3.467v3.6h5.027c.117 0 .254 0 .352.019 1.135.057 1.976.628 1.976 1.619 0 .78-.568 1.447-1.624 1.58v.039c1.154.076 2.034.705 2.034 1.676 0 1.048-.978 1.733-2.269 1.733h-5.515V22.4h5.222c1.956 0 3.56-1.543 3.56-3.467V1.62h-5.203z",
    fill: "url(#jcb_32_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.976 10.552c0-.457-.333-.762-.724-.819-.04 0-.137-.019-.196-.019h-1.858v1.676h1.858c.06 0 .177 0 .196-.019.391-.057.724-.362.724-.819z",
    fill: "url(#jcb_32_svg__c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.34 1.619c-1.956 0-3.56 1.543-3.56 3.467v8.552c.997.476 2.034.781 3.07.781 1.233 0 1.898-.724 1.898-1.714V8.667h3.051v4.019c0 1.562-.997 2.838-4.381 2.838-2.054 0-3.658-.438-3.658-.438v7.295h5.223c1.956 0 3.56-1.543 3.56-3.467V1.62H5.34z",
    fill: "url(#jcb_32_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.179 1.619c-1.956 0-3.56 1.543-3.56 3.467v4.533c.9-.743 2.464-1.219 4.987-1.105 1.35.057 2.797.42 2.797.42V10.4c-.723-.362-1.584-.686-2.699-.762-1.917-.133-3.07.781-3.07 2.381 0 1.62 1.153 2.533 3.07 2.381 1.115-.076 1.976-.42 2.7-.762v1.467s-1.428.362-2.798.419c-2.523.114-4.088-.362-4.987-1.105v8h5.222c1.956 0 3.56-1.543 3.56-3.467V1.62h-5.222z",
    fill: "url(#jcb_32_svg__e)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_32_svg__a",
    x1: "21.454",
    y1: "13.336",
    x2: "30.244",
    y2: "13.336",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_32_svg__b",
    x1: "21.453",
    y1: "12.001",
    x2: "30.244",
    y2: "12.001",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_32_svg__c",
    x1: "21.454",
    y1: "10.55",
    x2: "30.244",
    y2: "10.55",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".229",
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".743",
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_32_svg__d",
    x1: "1.776",
    y1: "12.001",
    x2: "10.701",
    y2: "12.001",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".475",
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".826",
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "jcb_32_svg__e",
    x1: "11.568",
    y1: "12.001",
    x2: "20.237",
    y2: "12.001",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".173",
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".573",
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".859",
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#E60039"
  }))));
};

Jcb32.defaultProps = {
  width: "32",
  height: "24",
  viewBox: "0 0 32 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var sizeMap = {
  '24': Jcb24,
  '32': Jcb32
};
export var Jcb = function Jcb(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? '24' : _ref$size,
      props = _objectWithoutProperties(_ref, _excluded);

  var Icon = sizeMap[size] || sizeMap['24'];

  if (process.env.NODE_ENV !== 'production' && process.env.NODE_ENV !== 'test' && !sizeMap[size]) {
    throw new Error("The '".concat(size, "' size is not supported by the 'Jcb' icon. Please use one of the available sizes: '24', '32'."));
  }

  return /*#__PURE__*/React.createElement(Icon, props);
};